/**
 * Keywords Everywhere - Keyword Tool
 *
 * SEO tool exposing per-platform stats panels to all origins.
 *
 * Behavioural discovery (tooling/batch-interactions.js) found no usable page-side
 * marker, so detection falls back to resource probing.
 * Manifest verified against version 11.53.
 */
import { probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';
const ID = 'hbapdpeemoojbophdfndmlgdhppljgmp';
export const keywordsEverywhere: ExtensionDefinition = {
  id: ID,
  name: "Keywords Everywhere - Keyword Tool",
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 1000000,
  notes: "SEO tool exposing per-platform stats panels to all origins.",
  signals: [
    { id: 'war-html-ytstats-html', kind: 'web-accessible-resource',
      description: 'Fetch html/ytstats.html, exposed to every origin.',
      weight: 1, run: () => probeFetch(ID, 'html/ytstats.html') },
    { id: 'war-html-igstats-html', kind: 'web-accessible-resource',
      description: 'Fetch html/igstats.html, exposed to every origin.',
      weight: 0.5, run: () => probeFetch(ID, 'html/igstats.html') },
  ],
};
